/* eslint-disable */

const YTPlayer = require('yt-player');

var current_window_size = $(window).width();

//-- Global functions
function get_window_width(){
  var overflow_x = $('body').css('overflow-x');
  var overflow_y = $('body').css('overflow-y');

  $('body').css('overflow', 'hidden');

  var window_width = $(window).width();

  $('body').css({ 'overflowX': overflow_x, 'overflowY': overflow_y });

  return window_width;
}

var window_width = get_window_width();


function definite_resize(){
  var definite_resize = false;

  if( current_window_size !== $(window).width() ){
    definite_resize = true;
  }

  current_window_size = $(window).width();

  return definite_resize;
}

export default {
  init() {
    // JavaScript to be fired on all pages

    // Header + navigation sticky on scroll
    const header = document.querySelector('.the-header');

    if (header) {
      const headerHeight = header.offsetHeight;

      // On scroll past headerHeight, add sticky class
      window.addEventListener('scroll', () => {
        if (window.scrollY > headerHeight) {
          header.classList.remove('not-ab');

          // Add padding to body to prevent jump
          document.body.style.paddingTop = `${headerHeight}px`;
        } else {
          header.classList.add('not-ab');

          // Remove padding from body
          document.body.style.paddingTop = 0;
        }
      });
    }

    // Match height
	// $('.match_height').matchHeight();

	 // Toggle mobile menu
    $('#nav_toggle').click(function(){
    	$(this).toggleClass('is-active');
      $('body').toggleClass('menu_open');
      $('#mobile_menu').stop().slideToggle();
    });

  // Toggle search bar
  $('.search-menu-toggle').click(function(){
    $(".search-fade-anchor").fadeOut(250, () => {
      $(".mobile-search-bar").fadeIn(250);
    });
  });

  $('.mobile-search-bar-close-icon').click(function(){
    $(".mobile-search-bar").fadeOut(250, () => {
      $(".search-fade-anchor").fadeIn(250);
    });
  });

   //  // Toggle mobile menu children
   //  $('#mobile_menu .mobile_menu_nav > li .toggle').click(function(){
   //    $(this).toggleClass('open');

   //    var $target = $(this).next().stop().slideToggle();

   //    $('ul.sub-menu').not($target).slideUp();
   //    $('.toggle').not(this).removeClass('open');

   //    // $(this).next().stop().slideToggle();
   //  });


    // Acknowledgement slider
    $('#ack_slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1199.99,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          }
        },
        {
          breakpoint: 991.99,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          }
        },

        {
          breakpoint: 767.99,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },

        {
          breakpoint: 576.99,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
          }
        },
      ]
    });

    // Home page slider
    if ($('#home-banner-carousel').length > 0) {
      $('#home-banner-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        speed: 600,
        autoplaySpeed: 4000,
      });

      const carouselControlsNext = $('.carousel-controls .next');
      const carouselControlsPrev = $('.carousel-controls .prev');

      carouselControlsNext.on('click', () => {
        $('#home-banner-carousel').slick('slickNext');
      });

      carouselControlsPrev.on('click', () => {
        $('#home-banner-carousel').slick('slickPrev');
      });
      
    }

    // Photo gallery
    // $(document).ready(function() {
      $('#photo_gallery').lightGallery({
        selector: '.image',
        mode: 'lg-fade',
        cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)'
      }); 
    // });

    // Photo gallery
    //-- Trigger gallery with text link
    $('#gallery_open').click(function() {
      $('#photo_gallery .large_image > div').trigger('click');
    });

    // Expandable acknowledgement logos
    $('.acknowledgements .seperator > span').click(function(event) {
      $(this).parent().toggleClass('open');
      $('.ack_logos.hidden').toggleClass('show');
      // $('.ack_logos.hidden').slideToggle();

      if( $(this).parent().hasClass('open') ) {
        $('span.closed').hide();
        $('span.open').show();
      } else {
        $('span.closed').show();
        $('span.open').hide();
      }
    });


  // Productions large slider
    var large_prod_slider = $('#large_view_slider');
    large_prod_slider.on('init', function(event, slick){
      var slider_count = slick.slideCount; // slide count
      var active_nav_width = (100 / slider_count); // calc % based on slide count

      $('#production_nav .nav .slick-dots li').css('width', active_nav_width + '%'); // set width
    }).slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      draggable: false,
      dots: true,
      appendDots: '#production_nav .nav',
      customPaging: function(slider, i) {
        return '<span class="bar"></span>';
      },
      autoplay: false
    });

    // change current slide value on slide change
    large_prod_slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
      var current_slide = (currentSlide + 1);

      $('#production_nav .count .current').html(current_slide);
    });

    // Large slider custom nav
    $('#prev_slide').click(function(){ large_prod_slider.slick('slickPrev'); });
    $('#next_slide').click(function(){ large_prod_slider.slick('slickNext'); });


  // Productions draggable slider
    var interactive_slider = $('#interactive_slider');
    $('#interactive_slider_tab').click(function(event) {
      interactive_slider.slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: false,
        responsive: [
          {
            breakpoint: 991.98,
            settings: {
              slidesToShow: 1
            }
          },
        ]
      });
    });

    // Offset slider on right
    var container_width = $('.container').width();
    var slider_offset = Math.round(window_width - container_width) + 20;

    if ( $(window).width() >= 992 ) {
      interactive_slider.css('margin-right', '-' + slider_offset + 'px');
    }


  // Productions draggable slider cursor
    if ( $(window).width() >= 1200 ) {
      var ball = $('.cursor .ball');
      var posX = 0, posY = 0;
      var mouseX = 0, mouseY = 0;

      $('#interactive_slider').on('mousemove', onMouseMove);
      $('#interactive_slider').on('mouseenter', onMouseHover);
      $('#interactive_slider').on('mouseleave', onMouseHoverOut);
      $('#interactive_slider .production .inr').on('mouseenter', onMouseHoverOut);
      $('#interactive_slider .production .inr').on('mouseleave', onMouseHover);

      TweenMax.to({}, 0.016, {
        repeat: -1,
        onRepeat: function() {
          posX += (mouseX - posX) / 9;
          posY += (mouseY - posY) / 9;
          
          TweenMax.set(ball, {
            css: {    
              left: mouseX -60,
              top: mouseY - 160
            }
          });
        }
      });

      function onMouseMove(e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
      }

      function onMouseHover() {
        ball.addClass('active');

        TweenMax.to(ball, 0.3, {
          scale: 1.5
        });
      }

      function onMouseHoverOut() {
        ball.removeClass('active');

        TweenMax.to(ball, 0.3, {
          scale: 1
        });
      }
    }


    $('select#category').niceSelect();

    // Fit Text
    $('.fit_text').bigtext();

    // Category filter submit on change
    $('#category').change(function() {
      this.form.submit();
    });

    /**
     * YouTube video embed
     */

    // Banner
    if ($('#banner_video').length > 0) {
      const videoId = $('#banner_video').data('video-id');
      const bannerVideo = new YTPlayer('#banner_video', {
        width: '100%',
        height: '100%',
        controls: false,
        annotations: false,
        related: false,
        keyboard: false,
        modestBranding: true,
      });

      bannerVideo.load(videoId);
      bannerVideo.mute();
      bannerVideo.play();

      bannerVideo.on('ended', () => {
        bannerVideo.play();
      });
    }

    // Other videos
    if ($('.video_wrap').length > 0) {
      $('.video_wrap').each(function() {
        const videoId = $(this).find('.feat-vid').data('video-id');
        const wrapId = $(this).find('.feat-vid').attr('id');

        if (!videoId) return;
        if (!wrapId) return;

        const video = new YTPlayer(`#${wrapId}`, {
          width: '100%',
          height: '100%',
          controls: false,
          annotations: false,
          related: false,
          keyboard: false,
          modestBranding: true,
        });

        video.load(videoId);

        const $this = $(this);

        $(this).find('.play').on('click', function() {
          video.play();
          $this.find('.feat-vid-poster').addClass('d-none');
          $this.find('.stopped').stop().fadeOut();
          $this.find('.playing').addClass('visible');
          $this.addClass('playing');
        });
  
        $(this).find('.pause').on('click', function() {
          video.pause();
          $this.find('.playing').removeClass('visible');
          $this.find('.stopped').stop().fadeIn();
          $this.removeClass('playing');
        });
  
        video.on('ended', () => {
          $this.find('.feat-vid-poster').removeClass('d-none');
          $this.find('.playing').removeClass('visible');
          $this.find('.stopped').stop().fadeIn();
          $this.removeClass('playing');
        });
  
        video.on('paused', () => {
          $this.find('.playing').removeClass('visible');
          $this.find('.stopped').stop().fadeIn();
          $this.removeClass('playing');
        });
  
        video.on('playing', () => {
          $this.find('.feat-vid-poster').addClass('d-none');
          $this.find('.stopped').stop().fadeOut();
          $this.find('.playing').addClass('visible');
          $this.addClass('playing');
        });
      });
    }

    if ($('#feat-vid').length > 0) {
      const videoId = $('#feat-vid').data('video-id');
      const video = new YTPlayer('#feat-vid', {
        width: '100%',
        height: '100%',
        controls: false,
        annotations: false,
        related: false,
        keyboard: false,
        modestBranding: true,
      });

      video.load(videoId);
    }


    //     /**
    //  * initMap
    //  *
    //  * Renders a Google Map onto the selected jQuery element
    //  *
    //  * @date    22/10/19
    //  * @since   5.8.6
    //  *
    //  * @param   jQuery $el The jQuery element.
    //  * @return  object The map instance.
    //  */
    // function initMap( $el ) {

    //     // Find marker elements within map.
    //     var $markers = $el.find('.marker');

    //     // Create gerenic map.
    //     var mapArgs = {
    //       zoom        : 16,
    //       mapTypeId   : google.maps.MapTypeId.ROADMAP,
    //       styles : [
    //         {
    //           "featureType": "all",
    //           "elementType": "labels.text.fill",
    //           "stylers": [
    //             {
    //               "color": "#ffffff"
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "all",
    //           "elementType": "labels.text.stroke",
    //           "stylers": [
    //             {
    //               "color": "#000000"
    //             },
    //             {
    //               "lightness": 13
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "administrative",
    //           "elementType": "geometry.fill",
    //           "stylers": [
    //             {
    //               "color": "#000000"
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "administrative",
    //           "elementType": "geometry.stroke",
    //           "stylers": [
    //             {
    //               "color": "#144b53"
    //             },
    //             {
    //               "lightness": 14
    //             },
    //             {
    //               "weight": 1.4
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "landscape",
    //           "elementType": "all",
    //           "stylers": [
    //             {
    //               "color": "#08304b"
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "poi",
    //           "elementType": "geometry",
    //           "stylers": [
    //             {
    //               "color": "#0c4152"
    //             },
    //             {
    //               "lightness": 5
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "road.highway",
    //           "elementType": "geometry.fill",
    //           "stylers": [
    //             {
    //               "color": "#000000"
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "road.highway",
    //           "elementType": "geometry.stroke",
    //           "stylers": [
    //             {
    //               "color": "#0b434f"
    //             },
    //             {
    //               "lightness": 25
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "road.arterial",
    //           "elementType": "geometry.fill",
    //           "stylers": [
    //             {
    //               "color": "#000000"
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "road.arterial",
    //           "elementType": "geometry.stroke",
    //           "stylers": [
    //             {
    //               "color": "#0b3d51"
    //             },
    //             {
    //               "lightness": 16
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "road.local",
    //           "elementType": "geometry",
    //           "stylers": [
    //             {
    //               "color": "#000000"
    //             }
    //           ]
    //         },
    //         {
    //           "featureType": "transit",
    //           "elementType": "all",
    //           "stylers": [
    //             {
    //               "color": "#146474"
    //             }
    //           ]
    //         },
    //         {
    //             "featureType": "water",
    //             "elementType": "all",
    //             "stylers": [
    //               {
    //                 "color": "#021019"
    //               }
    //             ]
    //         }
    //       ]
    //     };
    //     var map = new google.maps.Map( $el[0], mapArgs );

    //     // Add markers.
    //     map.markers = [];
    //     $markers.each(function(){
    //       initMarker( $(this), map );
    //     });

    //     // Center map based on markers.
    //     centerMap( map );

    //     // Return map instance.
    //     return map;
    // }

    // /**
    //  * initMarker
    //  *
    //  * Creates a marker for the given jQuery element and map.
    //  *
    //  * @date    22/10/19
    //  * @since   5.8.6
    //  *
    //  * @param   jQuery $el The jQuery element.
    //  * @param   object The map instance.
    //  * @return  object The marker instance.
    //  */
    // function initMarker( $marker, map ) {

    //   // Get position from marker.
    //   var lat = $marker.data('lat');
    //   var lng = $marker.data('lng');
    //   var latLng = {
    //     lat: parseFloat( lat ),
    //     lng: parseFloat( lng )
    //   };

    //   var marker_icon = {
    //     url: $marker.attr('data-icon'),
    //     scaledSize : new google.maps.Size(50, 50),
    //   };

    //   // Create marker instance.
    //   var marker = new google.maps.Marker({
    //     position : latLng,
    //     map: map,
    //     icon: marker_icon,
    //     title: $marker.data('name')
    //   });

    //   // Append to reference for later use.
    //   map.markers.push( marker );


    //   // If marker contains HTML, add it to an infoWindow.
    //   if( $marker.html() ){
    //     // Create info window.
    //     var infowindow = new google.maps.InfoWindow({
    //       content: $marker.html()
    //     });

    //     // Show info window when marker is clicked.
    //     google.maps.event.addListener(marker, 'click', function() {
    //       map.setZoom(10);
    //       map.setCenter( marker.getPosition() );

    //       // window.setTimeout(() => {
    //       infowindow.open( map, marker );
    //     // }, 1000);
    //     });
    //   }
    // }

    // /**
    //  * centerMap
    //  *
    //  * Centers the map showing all markers in view.
    //  *
    //  * @date    22/10/19
    //  * @since   5.8.6
    //  *
    //  * @param   object The map instance.
    //  * @return  void
    //  */
    // function centerMap( map ) {
    //   // Create map boundaries from all map markers.
    //   var bounds = new google.maps.LatLngBounds();
    //   map.markers.forEach(function( marker ){
    //     bounds.extend({
    //         lat: marker.position.lat(),
    //         lng: marker.position.lng()
    //     });
    //   });

    //   // Case: Single marker.
    //   if( map.markers.length == 1 ){
    //     map.setCenter( bounds.getCenter() );

    //   // Case: Multiple markers.
    //   } else {
    //     map.fitBounds( bounds );
    //   }
    // }

    // // Render maps on page load.
    // $(document).ready(function(){
    //   $('.acf-map').each(function(){
    //     var map = initMap( $(this) );
    //   });
    // });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(window).load(function() {
      $('body').addClass('loaded');
    });

    // AOS.init();
    $(function() {
      AOS.init({
        // offset: 100,
        // duration:700,
        // easing:'ease-in-out',
        once:true
      });

      window.addEventListener('load', AOS.refresh);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js